import { useState } from "react";
import { useAppContext } from "../../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../../controller/article/ArticleController";
import EnumReviewStatus from "../../../../utils/enum/EnumReviewStatus";
import { handleErrorMessage, useEffectOnce } from "../../../../utils/Utils";

interface ArticleRevisionServiceType {
  minorList: any;
  majorList: any;
  correctionList: any;
  tabSelected: number;
  handleChangeTab: any;
}

export default function ArticleRevisionService(): ArticleRevisionServiceType {
  const { axiosGetMyArticleWithStatus }: ArticleControllerType = ArticleController();
  const { showMessage, setBlockUI } = useAppContext();
  const [minorList, setMinorList] = useState([]);
  const [majorList, setMajorList] = useState([]);
  const [correctionList, setCorrectionList] = useState([]);
  const [tabSelected, setTabSelected] = useState(0);

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabSelected(newValue);
  };

  const statusList = [EnumReviewStatus.MINOR_REVISION, EnumReviewStatus.MAJOR_REVISION, EnumReviewStatus.CORRECTION];

  useEffectOnce(() => {
    setBlockUI(true);
    axiosGetMyArticleWithStatus(statusList)
      .then((result: any) => {
        const minor = result.data.filter((a: any) => a.status === EnumReviewStatus.MINOR_REVISION);
        const major = result.data.filter((a: any) => a.status === EnumReviewStatus.MAJOR_REVISION);
        const correction = result.data.filter((a: any) => a.status === EnumReviewStatus.CORRECTION);

        setMinorList(minor);
        setMajorList(major);
        setCorrectionList(correction);

        if (minor.length === 0) {
          if (major.length > 0) {
            setTabSelected(1);
          } else if (correction.length > 0) {
            setTabSelected(2);
          }
        }
      })
      .catch((error: any) => handleErrorMessage(showMessage, error))
      .finally(() => setBlockUI(false));
  });

  return {
    minorList,
    majorList,
    correctionList,
    tabSelected,
    handleChangeTab,
  };
}

export type { ArticleRevisionServiceType };
